function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.5 34.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m63,34.1c-5,0-9.3-1.6-12.5-4.8-3.3-3.2-4.9-7.3-4.9-12.2s1.7-9,5-12.2c3.3-3.3,7.5-4.9,12.3-4.9,5.4,0,9.9,2.1,13.6,6.2l.4.4-5.3,6-.5-.6c-2.1-2.6-4.7-3.9-7.8-3.9-2.5,0-4.6.8-6.4,2.4-1.8,1.6-2.6,3.8-2.6,6.5s.8,5,2.5,6.6c1.7,1.7,3.6,2.5,6,2.5,3.3,0,5.9-1.3,8-3.9l.5-.6,5.5,5.7-.4.5c-3.9,4.2-8.3,6.3-13.4,6.3Z",
    style: {
      fill: "#323b41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.9 33.7 79.9 .6 107.2 .6 103.8 8.2 88.3 8.2 88.3 13.7 101.3 13.7 98 21.2 88.3 21.2 88.3 33.7 79.9 33.7",
    style: {
      fill: "#323b41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.7 .6 113 .6 98.3 33.7 108.3 33.7 117.4 11.3 121.4 21.2 118.4 21.2 115.4 28.8 124.5 28.8 126.4 33.7 136.5 33.7 121.7 .6",
    style: {
      fill: "#323b41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.4 33.7 37.4 33.7 35.4 28.8 26.3 28.8 29.4 21.2 32.3 21.2 28.3 11.3 28.5 10.1 32.7 .6 47.4 33.7",
    style: {
      fill: "#323b41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.7 .6 19.3 33.7 9.2 33.7 24 .6 32.7 .6",
    style: {
      fill: "#ea963d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.8 21.2 0 21.2 9.2 33.7 19.3 33.7 9.8 21.2",
    style: {
      fill: "#b5752d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcfa);
export default __webpack_public_path__ + "static/media/ACFA.9b20a34f8af650813d2fedcc1824886b.svg";
export { ForwardRef as ReactComponent };